<template>
	<b-form-group>
    	<slot :name="this.groupFor"></slot>
	</b-form-group>
</template>
<script type="text/javascript">
export default{
	name:'FITFormGroup',
	components:{
		
	},
	props:{
		groupFor:String
	}
}

</script>


// WEBPACK FOOTER //
// src/components/Form/FITFormGroup.vue